import { z } from "zod";
export const DTOForgeProjectFile = z.object({
    id: z.string(),
    name: z.string(),
    checksum: z.string(),
    pendingUpload: z.boolean().optional(),
    url: z.string(),
    size: z.number(),
});
export const DTOForgeProjectFileListResponse = z.object({
    files: z.array(DTOForgeProjectFile),
});
export const DTOForgeProjectFileUploadPayloadItem = z.object({
    size: z.number(),
    name: z.string(),
    checksum: z.string(),
});
export const DTOForgeProjectFileUploadPayload = z.object({
    files: z.array(DTOForgeProjectFileUploadPayloadItem),
});
export const DTOForgeProjectFileUploadResponse = z.object({
    files: z.array(DTOForgeProjectFile),
    uploadUrls: z.array(z.object({
        fileId: z.string(),
        uploadUrl: z.string(),
    })),
});
export const DTOForgeProjectFileUploadFinalizePayload = z.object({
    fileIds: z.array(z.string()),
});
export const DTOForgeProjectFileUploadFinalizeResponse = z.object({
    ok: z.literal(true),
});
